<div class="layout-dashboard ini-pagina">
    <div class="ini-cabecalho">
        <div>
            <h2>{{ saudacao }}, {{ nomeUsuario }}</h2>
            <span>{{ hoje | date: "EEEE, d 'de' MMMM 'de' y" }}</span>
        </div>
    </div>

    <div class="ini-indicadores">
        <div class="overview-box sales indicador">
            <div class="ini-indicador-texto">
                <div class="overview-title">Novos registros hoje</div>
                <div class="overview-numbers">{{registrosNovos}}</div>
            </div>
            <i class="pi pi-user-plus"></i>
        </div>
        <div class="overview-box checkins indicador">
            <div class="ini-indicador-texto">
                <div class="overview-title">Registros nos últimos 30 dias</div>
                <div class="overview-numbers">{{registrosNovosMes}}</div>
            </div>
            <i class="pi pi-chart-line"></i>
        </div>
        <div class="overview-box users indicador">
            <div class="ini-indicador-texto">
                <div class="overview-title">Vencem hoje</div>
                <div class="overview-numbers">{{vencemHoje}}</div>
            </div>
            <i class="pi pi-calendar"></i>
        </div>
        <div class="overview-box views indicador">
            <div class="ini-indicador-texto">
                <div class="overview-title">Venceram nos últimos 30 dias</div>
                <div class="overview-numbers">{{venceram30Dias}}</div>
            </div>
            <i class="pi pi-calendar-times"></i>
        </div>
    </div>

    <h3 class="ini-secao">Atalhos</h3>
    <div class="ini-atalhos">
        <a *ngFor="let a of atalhos" class="ini-atalho" [routerLink]="a.rota">
            <span class="ini-atalho-icone"><i [class]="a.icone"></i></span>
            <span class="ini-atalho-texto">
                <b>{{ a.titulo }}</b>
                <small>{{ a.descricao }}</small>
            </span>
            <i class="pi pi-arrow-right ini-atalho-seta"></i>
        </a>
    </div>
</div>
